<template>
  <div class="container py-5 pt-3 pt-xl-5">
    <CountryPickerComponent />
    <!-- Loading overlay, shown only when isLoading is true -->
    <LoadingOverlayComponent v-if="isLoading" />
    <!-- AccountDataDebugComponent for debugging -->
    <AccountDataDebugComponent
      :accountData="accountData"
      class="mb-4"
    ></AccountDataDebugComponent>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import CountryPickerComponent from "@/signup/CountryPickerComponent.vue";
import AccountDataDebugComponent from "@/components/common/AccountDataDebugComponent.vue";
import LoadingOverlayComponent from "@/components/common/LoadingOverlayComponent.vue";
import { useSignupStore } from "@/signup/signup";

defineOptions({ name: "EmptySignupFlow" });

const { account: accountData } = storeToRefs(useSignupStore());

const isLoading = ref(true);

onMounted(async () => {
  isLoading.value = false;
});
</script>
